import { create } from "zustand";
import { persist } from "zustand/middleware";
import { DateString } from "@/utils/types";

export type DjangoTokenResponse = {
  access: string;
  refresh: string;
  user?: {
    pk: number;
    email: string;
    first_name: string;
    last_name: string;
  };
  access_expiration?: DateString;
  refresh_expiration?: DateString;
};

type AuthState = {
  tokenResponse: DjangoTokenResponse | null;

  setTokenResponse: (t: DjangoTokenResponse) => void;
  clearAuth: () => void;

  getAccessToken: () => string | null;
  isAuthenticated: () => boolean;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      tokenResponse: null,

      setTokenResponse: (t) => set({ tokenResponse: t }),

      clearAuth: () => set({ tokenResponse: null }),

      getAccessToken: () => get().tokenResponse?.access ?? null,

      isAuthenticated: () => Boolean(get().tokenResponse?.access),
    }),
    {
      name: "auth-storage", // localStorage key
      partialize: (state) => ({ tokenResponse: state.tokenResponse }),
    }
  )
);
